import styled from '@emotion/styled';

import styles from 'app/components/v2/constants/styles';

// Local Typings
export type DeviceType = 'desktop' | 'mobile';

// Local Variables
const NavWrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.semanticColors.nav_background,
  borderBottom: `2px solid ${theme.semanticColors.nav_border}`,
  left: 0,
  position: 'relative',
  right: 0,
  zIndex: styles.zIndex.nav,
}));

export default NavWrapper;
